import {
  PROGRAM_MEMBER_GET_URL,
  PROGRAM_MEMBER_POST_URL,
  GET_DATA_SYSTEM_DROPDOWN_VALUES
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getDataSystemDropdownValues = () => (dispatch, getState) =>
  asyncRequest({
    url: GET_DATA_SYSTEM_DROPDOWN_VALUES(),
    successAction: data => ({
      type: types.GET_DATA_SYSTEM_DROPDOWN_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.GET_DATA_SYSTEM_DROPDOWN_FAILURE,
      payload: error
    }),
    dispatch
  });

export const getProgramMember = associationsNum => (dispatch, getState) =>
  asyncRequest({
    url: PROGRAM_MEMBER_GET_URL(associationsNum),
    successAction: data => ({
      type: types.GET_PROGRAM_MEMBER_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.GET_PROGRAM_MEMBER_FAILURE,
      payload: error
    }),
    dispatch
  });

export const postProgramMember = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: PROGRAM_MEMBER_POST_URL(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.POST_PROGRAM_MEMBER_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_PROGRAM_MEMBER_FAILURE,
      payload: error
    }),
    dispatch
  });
export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
